// todo move this file to module
export let ChatAccessOptions = {
    '1': 'ثبت نام شده',
    '0': 'غیر ثبت نام شده',
}